var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66602 2.6665H6.33268C6.88497 2.6665 7.33268 3.11422 7.33268 3.6665V4.33317C7.33268 4.88546 6.88497 5.33317 6.33268 5.33317H3.66602C3.11373 5.33317 2.66602 4.88546 2.66602 4.33317V3.6665C2.66602 3.11422 3.11373 2.6665 3.66602 2.6665ZM9.66602 10.6665H12.3327C12.885 10.6665 13.3327 11.1142 13.3327 11.6665V12.3332C13.3327 12.8855 12.885 13.3332 12.3327 13.3332H9.66602C9.11373 13.3332 8.66602 12.8855 8.66602 12.3332V11.6665C8.66602 11.1142 9.11373 10.6665 9.66602 10.6665Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66602 6.6665H6.33268C6.88497 6.6665 7.33268 7.11422 7.33268 7.6665V12.3332C7.33268 12.8855 6.88497 13.3332 6.33268 13.3332H3.66602C3.11373 13.3332 2.66602 12.8855 2.66602 12.3332V7.6665C2.66602 7.11422 3.11373 6.6665 3.66602 6.6665ZM9.66602 2.6665H12.3327C12.885 2.6665 13.3327 3.11422 13.3327 3.6665V8.33317C13.3327 8.88545 12.885 9.33317 12.3327 9.33317H9.66602C9.11373 9.33317 8.66602 8.88545 8.66602 8.33317V3.6665C8.66602 3.11422 9.11373 2.6665 9.66602 2.6665Z",
    fill: "#0078D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewActive);
export default __webpack_public_path__ + "static/media/overview_active.660f5484.svg";
export { ForwardRef as ReactComponent };